export default {
  state: {
    guestInformation: {
      show: false
    }
  },
  mutations: {
    showGuestInformation (state) { state.guestInformation.show = true },
    hideGuestInformation (state) { state.guestInformation.show = false }
  }
}



// WEBPACK FOOTER //
// ./src/store/rsvp-edit/guest-information.js